//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapGetters } from 'vuex';
import * as types from '~/types';

export default {
  props: ['hotThemeData', 'hotSubjectDatas'],
  data() {
    return {
      HotThemeList: [],
      list: [],
    };
  },

  computed: {
    ...mapGetters('user', ['isLogin', 'userId']),
  },
  watch: {
    isLogin() {
      this.$emit('hotSubject');
    },
  },
  mounted() {
    if (this.hotThemeData && this.hotThemeData.length > 0) {
      const list = this.hotThemeData.sort((a, b) => {
        return b.updateTimestamp - a.updateTimestamp;
      });
      this.list = list;
    }
  },
  methods: {
    ...mapMutations('user', [types.SHOW_LOGIN_FORM]),
    refresh() {
      this.$emit('refresh');
    },
  },
};
